import * as APITypes from "../graphql";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUserLite = /* GraphQL */ `query GetUserLite($userId: String) {
  getUserView(userId: $userId) {
    userId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      
      
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        organizationGroup
       
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
     
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userConnectionType
    currentUserConnectionType
    interests {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    expertises {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    fanCount
    
    userHomepageConfig
    userHomepageConfigMobile
    disabledQuickQuestion
    announcements {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserViewQueryVariables,
  APITypes.GetUserViewQuery
>;